module.exports = __webpack_public_path__ + "img/sequire-pr.6ee5bce0.png";